import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resize',
  pure: false,
})
export class ResizePipe implements PipeTransform {
  transform(url, w = 2048, h = 2048) {
    return url ? url.replace(/\/\d+x\d+\//, `/${w}x${h}/`) : url;
  }
}
